"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectToWhere = void 0;
function objectToWhere(where) {
    return where
        ? "where: { ".concat(Object.keys(where)
            .map(function (key) { return "".concat(key, ": \"").concat(where[key], "\""); })
            .join(","), " }")
        : "";
}
exports.objectToWhere = objectToWhere;
